class HeaderElement extends HTMLElement {
  connectedCallback () {
    this.levelStack = ['root']
    this.setupDesktopMenu()
    this.setupMobileMenu()
    this.setupSearchModal()
    this.setupMobileLevels()
    this.initializeMobileMenuPositioning()
    this.setupPageRestoreHandler()
  }

  setupPageRestoreHandler () {
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        this.hideMobileMenuLoadingSpinner()
      }
    })
  }

  setupDesktopMenu () {
    this.menuDesktopParents.forEach(menuDesktopParent => {
      const menuDrawer = menuDesktopParent.querySelector('[menu-drawer]')
      const topLink = menuDesktopParent.querySelector('.site-header__menu-item-link')
      if (!menuDrawer) return
      menuDesktopParent.addEventListener('mouseover', () => {
        menuDrawer.classList.remove('invisible', 'opacity-0')
        if (topLink) {
          topLink.classList.add('border-b-black')
          topLink.setAttribute('aria-expanded', 'true')
        }
        this.toggleSearchModal(false)
        window.dispatchEvent(new CustomEvent('show:body-obscure'))
      })

      menuDesktopParent.addEventListener('mouseout', () => {
        menuDrawer.classList.add('invisible', 'opacity-0')
        if (topLink) {
          topLink.classList.remove('border-b-black')
          topLink.setAttribute('aria-expanded', 'false')
        }
        window.dispatchEvent(new CustomEvent('hide:body-obscure'))
      })
    })
  }

  setupMobileMenu () {
    if (this.openMobileMenuTrigger) {
      this.openMobileMenuTrigger.addEventListener('click', () => {
        this.toggleMobileMenu(true)
      })
    }

    // Handle all elements with close-menu-mobile attribute
    const closeTriggers = this.querySelectorAll('[close-menu-mobile]')
    closeTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        if (trigger.classList.contains('chat__trigger')) {
          return
        }
        this.toggleMobileMenu(false)
      })
    })

    window.addEventListener('show:mobile-menu', () => {
      this.toggleMobileMenu(true)
    })

    window.addEventListener('hide:mobile-menu', () => {
      this.toggleMobileMenu(false)
    })
  }

  setupSearchModal () {
    if (this.openSearchModal) {
      this.openSearchModal.addEventListener('click', () => {
        this.toggleSearchModal(true)
      })
    }

    if (this.closeSearchModal) {
      this.closeSearchModal.addEventListener('click', () => {
        this.toggleSearchModal(false)
      })
    }

    if (this.cancelSearchModal) {
      this.cancelSearchModal.addEventListener('click', () => {
        this.toggleSearchModal(false)
      })
    }

    window.addEventListener('show:search-modal', () => {
      this.toggleSearchModal(true)
    })

    window.addEventListener('hide:search-modal', () => {
      this.toggleSearchModal(false)
    })
  }

  setupMobileLevels () {
    if (!this.mobileNav) return

    this.flattenMobileLevels()
    this.resetLevelsToRoot()
    this.setupMobileLevelFaders()

    this.mobileNav.addEventListener('click', (e) => {
      const openBtn = e.target.closest('[data-open-level]')
      if (openBtn) {
        const id = openBtn.getAttribute('data-open-level')
        this.openLevel(id)
        return
      }

      const backBtn = e.target.closest('[data-back]')
      if (backBtn) {
        this.goBackOneLevel(backBtn)
      }

      // Only act on anchor links that navigate away (not level openers)
      const linkEl = e.target.closest('a[href]')
      if (linkEl && !linkEl.hasAttribute('data-open-level')) {
        const href = linkEl.getAttribute('href') || ''
        // ignore hash-only navigation within menu
        if (href && !href.startsWith('#')) {
          this.showMobileMenuLoadingSpinner()
        }
      }
    })
  }

  openLevel (levelId) {
    const currentId = this.levelStack[this.levelStack.length - 1]
    const currentLevel = this.getLevel(currentId)
    const nextLevel = this.getLevel(levelId)
    if (!currentLevel || !nextLevel) return

    currentLevel.classList.remove('translate-x-0')
    currentLevel.classList.add('-translate-x-full')

    nextLevel.classList.remove('translate-x-full')
    nextLevel.classList.add('translate-x-0')
    nextLevel.classList.add('z-10')
    currentLevel.classList.remove('z-10')

    // Reset scroll position to top when navigating to a new level
    nextLevel.scrollTop = 0

    this.levelStack.push(levelId)
    this.updateLevelFader(nextLevel)
    this.updateFooterContactButtonForCurrentLevel()
  }

  goBackOneLevel (backBtn) {
    if (this.levelStack.length <= 1) return
    const currentId = this.levelStack.pop()
    const prevId = this.levelStack[this.levelStack.length - 1]

    const currentLevel = this.getLevel(currentId)
    const prevLevel = this.getLevel(prevId)
    if (!currentLevel || !prevLevel) return

    currentLevel.classList.remove('translate-x-0')
    currentLevel.classList.add('translate-x-full')

    prevLevel.classList.remove('-translate-x-full')
    prevLevel.classList.add('translate-x-0')
    prevLevel.classList.add('z-10')
    currentLevel.classList.remove('z-10')

    // Reset scroll position to top when navigating back to a previous level
    prevLevel.scrollTop = 0

    this.updateLevelFader(prevLevel)
    this.updateFooterContactButtonForCurrentLevel()
  }

  toggleMobileMenu (val) {
    const chatBundle = document.querySelector('.chat-bundle')
    const isMenuOpen = !this.mobileMenu.classList.contains('-translate-x-[102%]')

    if (val) {
      if (isMenuOpen) return
      this.mobileMenu.classList.remove('-translate-x-[102%]')
      this.openMobileMenuTrigger.classList.add('tb-hidden')
      this.closeMobileMenuTrigger.classList.remove('tb-hidden')
      const closeBox = this.closeMobileMenuTrigger.querySelector('div')
      if (closeBox) closeBox.classList.add('bg-oat', 'rounded-md', 'text-orange')
      this.toggleSearchModal(false)
      this.hideKlaviyoFlyouts()
      window.dispatchEvent(new CustomEvent('prevent:page-scroll'))
      window.dispatchEvent(new CustomEvent('show:body-obscure'))
      if (chatBundle) chatBundle.style.zIndex = '10'
      this.updateAllLevelFaders()
      this.updateFooterContactButtonForCurrentLevel()
      return
    }

    if (!isMenuOpen) return

    this.mobileMenu.classList.add('-translate-x-[102%]')
    this.openMobileMenuTrigger.classList.remove('tb-hidden')
    this.closeMobileMenuTrigger.classList.add('tb-hidden')
    const closeBox = this.closeMobileMenuTrigger.querySelector('div')
    if (closeBox) closeBox.classList.remove('bg-oat', 'rounded-md', 'text-orange')
    this.showKlaviyoFlyouts()
    // Reset levels back to root when closing
    this.resetLevelsToRoot()
    if (chatBundle) chatBundle.style.zIndex = '70'

    window.dispatchEvent(new CustomEvent('allow:page-scroll'))
    window.dispatchEvent(new CustomEvent('hide:body-obscure'))

    // Reset spinner state when menu closes
    this.hideMobileMenuLoadingSpinner()
  }

  resetLevelsToRoot () {
    if (!this.mobileNav) return
    const allLevels = this.mobileNav.querySelectorAll('.mobile-menu__level')
    allLevels.forEach(level => {
      const id = level.getAttribute('data-level-id')
      if (id === 'root') {
        level.classList.add('translate-x-0')
        level.classList.remove('translate-x-full', '-translate-x-full')
        level.classList.add('z-10')
        // Reset scroll position to top when returning to root
        level.scrollTop = 0
      } else {
        level.classList.add('translate-x-full')
        level.classList.remove('translate-x-0', '-translate-x-full', 'z-10')
      }
    })
    this.levelStack = ['root']
    const root = this.getLevel('root')
    if (root) this.updateLevelFader(root)
    this.updateFooterContactButtonForCurrentLevel()
  }

  toggleSearchModal (val) {
    if (!this.searchModal || !this.openSearchModal || !this.closeSearchModal) return
    if (val) {
      this.searchModal.classList.remove('tb-hidden')
      this.openSearchModal.classList.add('tb-hidden')
      this.closeSearchModal.classList.remove('tb-hidden')
      this.toggleMobileMenu(false)
      window.dispatchEvent(new CustomEvent('show:body-obscure'))
      if (this.searchInput) this.searchInput.focus()
      return
    }

    this.searchModal.classList.add('tb-hidden')
    this.openSearchModal.classList.remove('tb-hidden')
    this.closeSearchModal.classList.add('tb-hidden')
    window.dispatchEvent(new CustomEvent('hide:body-obscure'))
  }

  getLevel (id) {
    if (!this.mobileNav) return null
    const levels = this.mobileNav.querySelectorAll('.mobile-menu__level')
    for (const el of levels) {
      if (el.getAttribute('data-level-id') === id) return el
    }
    return null
  }

  setupMobileLevelFaders () {
    if (!this.mobileNav) return
    const levels = this.mobileNav.querySelectorAll('.mobile-menu__level')
    levels.forEach(level => this.ensureLevelFader(level))
    levels.forEach(level => {
      if (!level._faderScrollBound) {
        level.addEventListener('scroll', () => this.updateLevelFader(level))
        level._faderScrollBound = true
      }
      this.updateLevelFader(level)
    })
    if (!this._faderResizeBound) {
      window.addEventListener('resize', () => this.updateAllLevelFaders())
      this._faderResizeBound = true
    }
  }

  ensureLevelFader (level) {
    if (!level) return null
    return level.querySelector('.mobile-menu__fader')
  }

  updateLevelFader (level) {
    if (!level) return
    const fader = this.ensureLevelFader(level)
    if (!fader) return
    const scrollHeight = level.scrollHeight || 0
    const clientHeight = level.clientHeight || 0
    const scrollTop = level.scrollTop || 0
    const canScroll = scrollHeight > clientHeight + 1
    const atBottom = scrollTop + clientHeight >= scrollHeight - 1
    if (canScroll && !atBottom) {
      fader.classList.remove('opacity-0')
      fader.classList.add('opacity-100')
    } else {
      fader.classList.remove('opacity-100')
      fader.classList.add('opacity-0')
    }
  }

  updateAllLevelFaders () {
    if (!this.mobileNav) return
    const levels = this.mobileNav.querySelectorAll('.mobile-menu__level')
    levels.forEach(level => this.updateLevelFader(level))
  }

  updateFooterContactButtonForCurrentLevel () {
    const greenBtn = this.greenContactButton
    const defaultBtn = this.defaultContactButton
    if (!greenBtn || !defaultBtn) return
    const currentId = this.levelStack[this.levelStack.length - 1]
    const level = this.getLevel(currentId)
    const isGreen = !!(level && level.hasAttribute('data-root-green'))
    if (isGreen) {
      defaultBtn.classList.add('hidden')
      greenBtn.classList.remove('hidden')
    } else {
      greenBtn.classList.add('hidden')
      defaultBtn.classList.remove('hidden')
    }
  }

  get menuDesktopParents () {
    return this.querySelectorAll('[menu-parent]')
  }

  initializeMobileMenuPositioning () {
    this.updateMobileMenuPosition()

    // Update on scroll and resize
    let ticking = false
    const updatePosition = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          this.updateMobileMenuPosition()
          ticking = false
        })
        ticking = true
      }
    }

    window.addEventListener('scroll', updatePosition, { passive: true })
    window.addEventListener('resize', updatePosition)
  }

  calculateTotalHeaderHeight () {
    let totalHeight = 0

    // Get announcement bar height only if it's visible in viewport
    const announcementBar = document.querySelector('.announcement-bar')
    if (announcementBar) {
      const rect = announcementBar.getBoundingClientRect()
      // Only count height if the element is visible at the top (not scrolled past)
      if (rect.top >= -5 && rect.bottom > 0) { // Small buffer for precision
        totalHeight += rect.height
      }
    }

    // Get main header height (always visible due to fixed/sticky positioning)
    const siteHeader = document.querySelector('.site-header')
    if (siteHeader) {
      const rect = siteHeader.getBoundingClientRect()
      totalHeight += rect.height
    }

    // Promo bar height is ignored for mobile menu positioning
    return totalHeight
  }

  updateMobileMenuPosition () {
    const totalHeaderHeight = this.calculateTotalHeaderHeight()

    // Set CSS custom property for total header height to use in height calculation
    document.documentElement.style.setProperty('--total-header-height', `${totalHeaderHeight}px`)
  }

  get mobileMenu () {
    return this.querySelector('[mobile-menu]')
  }

  get mobileNav () {
    return this.querySelector('[data-mobile-nav]')
  }

  get openMobileMenuTrigger () {
    return this.querySelector('[open-menu-mobile]')
  }

  get closeMobileMenuTrigger () {
    return this.querySelector('[close-menu-mobile]')
  }

  get searchModal () {
    return this.querySelector('[search-modal]')
  }

  get openSearchModal () {
    return this.querySelector('[open-search-modal]')
  }

  get closeSearchModal () {
    return this.querySelector('[close-search-modal]')
  }

  get cancelSearchModal () {
    return this.querySelector('[cancel-search-modal]')
  }

  get searchInput () {
    return this.querySelector('[search-input]')
  }

  get defaultContactButton () {
    return this.querySelector('.mobile-menu__footer-contact-button')
  }

  get greenContactButton () {
    return this.querySelector('.mobile-menu__footer-contact-button--green')
  }

  flattenMobileLevels () {
    const levels = this.mobileNav ? this.mobileNav.querySelectorAll('.mobile-menu__level') : []
    levels.forEach(level => {
      if (level.parentElement !== this.mobileNav) {
        this.mobileNav.appendChild(level)
      }
    })
  }

  showMobileMenuLoadingSpinner () {
    const closeBtn = this.closeMobileMenuTrigger
    if (!closeBtn) return
    const closeIcon = closeBtn.querySelector('.site-header__menu-mobile-close-icon')
    const spinner = closeBtn.querySelector('.loading-overlay__spinner')
    if (closeIcon) closeIcon.classList.add('opacity-0')
    if (spinner) spinner.classList.remove('opacity-0')
  }

  hideMobileMenuLoadingSpinner () {
    const closeBtn = this.closeMobileMenuTrigger
    if (!closeBtn) return
    const closeIcon = closeBtn.querySelector('.site-header__menu-mobile-close-icon')
    const spinner = closeBtn.querySelector('.loading-overlay__spinner')
    if (spinner) spinner.classList.add('opacity-0')
    if (closeIcon) closeIcon.classList.remove('opacity-0')
  }

  getKlaviyoFlyoutContainers () {
    const containers = []
    const flyoutElements = document.querySelectorAll('[data-testid="FLYOUT"], [aria-label*="FLYOUT"]')
    flyoutElements.forEach(el => {
      let current = el
      while (current && current.parentElement) {
        current = current.parentElement
        const hasKlaviyoClass = Array.from(current.classList || []).some(cls => cls.startsWith('kl-private-reset-css-'))
        if (hasKlaviyoClass && current.parentElement && !current.parentElement.classList.length) {
          if (!containers.includes(current.parentElement)) {
            containers.push(current.parentElement)
          }
          break
        }
      }
    })
    return containers
  }

  hideKlaviyoFlyouts () {
    const containers = this.getKlaviyoFlyoutContainers()
    containers.forEach(container => {
      if (container && container.style) {
        container.setAttribute('data-original-display', container.style.display || '')
        container.style.display = 'none'
      }
    })
  }

  showKlaviyoFlyouts () {
    const containers = this.getKlaviyoFlyoutContainers()
    containers.forEach(container => {
      if (container && container.style) {
        const originalDisplay = container.getAttribute('data-original-display')
        if (originalDisplay !== null) {
          container.style.display = originalDisplay
          container.removeAttribute('data-original-display')
        }
      }
    })
  }
}

if (!customElements.get('header-element')) {
  customElements.define('header-element', HeaderElement)
}
